import {lazyRegister} from '@/Core/lazyRegister';
import template from './search-icon-action.component.html';

class SearchIconActionController implements ng.IController {
    static $inject = [
        '$element',
    ];

    onSearch: () => void;

    constructor(private readonly $element
    ) {
    }

    $onInit(): void {
        this.$element.addClass('relative inline-block group/search-icon-action');
    }

    handleSearch(event: Event): void {
        event.stopPropagation();
        this.onSearch?.();
    }
}

export const SearchIconActionComponent: ng.IComponentOptions = {
    transclude: true,
    bindings: {
        onSearch: '&'
    },
    template: template,
    controller: SearchIconActionController
};

lazyRegister.component('searchIconAction', SearchIconActionComponent);
